module.exports = __webpack_public_path__ + "static/img/open_record.1626146.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/wxMini/open_record.jpg
// module id = xCII
// module chunks = 0